export default `
mutation recarga(
    $idProposta: String
    $captchaResponse: String
    $valorRecargaPrePago: Int
  ) {
    recargaFCG(
      payload: {
        id: $idProposta
        captchaResponse: $captchaResponse
        pedido: {
          plano: { valorRecargaPrePago: $valorRecargaPrePago }
        }
      }
    ) {
      dados {
        id
        situacaoProposta
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
